import { useSearchParams } from "react-router-dom";

const HomePage = () => {

  const [searchParams] = useSearchParams();
  const currentLinkKey = searchParams.get('link');

  const PROJECTS_DATA = {
    "ameer_printing": {
      facebook: "https://www.facebook.com/profile.php?id=100092013173854",
      instagram: "https://www.instagram.com/alamer.printing"
    },
    "printer_parts": {
      facebook: "#",
      instagram: "#"
    },
    "ameer_advertising": {
      facebook: "https://www.facebook.com/alamer.adv?rdid=cIC3dMytUBTPtdbF&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F16teCN1riD%2F#",
      instagram: "https://www.instagram.com/alamer.printing"
    },
    "acrylic_art": {
      facebook: "#",
      instagram: "#"
    },
    "sublimation": {
      facebook: "https://www.facebook.com/people/Saf-%D8%B9%D8%A7%D9%84%D9%85-%D8%A7%D9%84%D8%B3%D8%A8%D9%84%D9%85%D9%8A%D8%B4%D9%86/61570908848161/?rdid=OCFGtxhEYOZ3BCSe&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1ZUwr8tXSq%2F",
      instagram: "https://www.instagram.com/sublimationforeverything"
    },
    "uv": {
      facebook: "https://www.facebook.com/people/Uv-House/61570605917319/",
      instagram: "https://www.instagram.com/uvhouse8"
    }
  };

  const activeLinks = PROJECTS_DATA[currentLinkKey] || "#";

  return (
    <div className="redirect_container" dir="rtl">
      <div className="bg_shape shape_1"></div>
      <div className="bg_shape shape_2"></div>

      <div className="redirect_card">
        <div className="mb-8">
          <img
            src="/assets/images/logo.png"
            alt="شعار مجموعة أمير"
            className="h-24 mx-auto object-contain"
          />
        </div>

        <div className="space-y-4 mb-8">
          <h1 className="text-2xl md:text-3xl font-bold text-[var(--color-text-primary)]">
            أهلاً بكم في  Ameer Group
          </h1>
          <p className="text-[var(--color-text-secondary)] leading-relaxed text-lg">
            اكتشف أحدث تقنيات الطباعة الرقمية وتابع آخر التحديثات عبر مجتمعاتنا الرسمية على منصات التواصل الاجتماعي.
          </p>
        </div>

        <div className="flex flex-col gap-4">
          <a
            href={activeLinks.facebook}
            target="_blank"
            rel="noopener noreferrer"
            className="btn_social facebook_btn"
          >
            <span>تابعنا على فيسبوك</span>
          </a>

          <a
            href={activeLinks.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="btn_social instagram_btn"
          >
            <span>تابعنا على إنستغرام</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default HomePage;